import { Children, cloneElement, Component } from 'react';
import * as ReactDOM from 'react-dom';

export interface IState {
  isMounted: boolean;
}

export class Portal extends Component {
  public state: IState = {
    isMounted: false,
  };
  private rootSelector: any;
  private container: any;

  public componentDidMount() {
    this.container = document.createElement('div');
    this.rootSelector = document.getElementById('portal-root'); // portal-root is defined in UiProvider.
    if (this.rootSelector) {
      this.rootSelector.appendChild(this.container);
    }
    this.setState({ isMounted: true });
  }

  public componentWillUnmount() {
    if (this.rootSelector) {
      this.rootSelector.removeChild(this.container);
    }
  }

  public render() {
    // Don't render the portal until the component has mounted,
    // so the portal can safely access the DOM.
    if (!this.state.isMounted) {
      return null;
    } else {
      const c: any = Children.only(this.props.children);
      return <>{ReactDOM.createPortal(cloneElement(c, this.props), this.container)}</>;
    }
  }
}

export default Portal;
